// @flow

import { DISPLAY_CONFIRMATION, DISMISS_CONFIRMATION } from './constants';

import type { ConfirmationKind, ConfirmationResponse, Action } from '../types';

export const displayConfirmation = (kind: ConfirmationKind): Action => ({
  type: DISPLAY_CONFIRMATION,
  kind
});

export const dismissConfirmation = (response: ConfirmationResponse): Action => ({
  type: DISMISS_CONFIRMATION,
  response
});
